<template>
    <div v-if="video">
        <div
            class="video-placeholder"
            @click="openModal"
            :style="`background-image: linear-gradient(rgba(128,128,128,0.1), rgba(128,128,128,0.1)), url('https://img.youtube.com/vi/${video.embedCode}/maxresdefault.jpg')`"
        >
            <img
                src="https://rhino-s3-test.s3.amazonaws.com/assets/ui/play-video-button.png"
                alt="Play Button"
                class="play-btn"
            />
        </div>
        <modal
            name="product-video-modal"
            :adaptive="true"
            :width="1280"
            :height="720"
        >
            <iframe
                width="100%"
                height="100%"
                :src="`https://www.youtube.com/embed/${video.embedCode}?rel=0`"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </modal>
    </div>
</template>

<script>
export default {
    name: "product-video",
    props: {
        videos: Array
    },
    computed: {
        video: function() {
            return this.videos[0]
        }
    },
    methods: {
        openModal() {
            this.$modal.show("product-video-modal");
        }
    }
};
</script>
